/**
 * CSS cursor values for X-ray viewer interaction affordances (landmark drag,
 * femur head circle resize).
 *
 * To swap to custom (e.g. Material Design) cursor artwork, replace each value
 * with `url('/cursors/<icon>.svg') <hot-x> <hot-y>, <fallback-keyword>`.
 * Generate the SVG/PNG assets from `@mdi/svg`.
 */
export const INTERACTION_CURSORS = {
    hoverLandmark: 'grab',
    dragging: 'grabbing',
    hoverCircleEdge: 'grab',
    default: 'default',
} as const;

export type InteractionCursor = (typeof INTERACTION_CURSORS)[keyof typeof INTERACTION_CURSORS];
